















































































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import AButton from '@/components/common/AButton.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { EyeIcon, EyeOffIcon, InfoIcon } from 'vue-feather-icons';
import { AuthApi } from '@/services/AuthApi';
import { FormMixin } from '@/mixins/FormMixin';
import { ResetPasswordModel } from 'admiral-core';
import ResetPasswordForm from '@/views/pages/auth/ResetPasswordForm.vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';

@Component({
  name: 'reset-password',
  components: { FormSubmit, ResetPasswordForm, AButton, EyeIcon, InfoIcon, EyeOffIcon },
})
class ResetPassword extends mixins(FormMixin, BaseMixin) {
  model = this.defaultModel();

  defaultModel(): ResetPasswordModel {
    return {
      password: '',
      passwordConfirm: '',
      code: '',
    };
  }

  done = false;
  error = '';

  async handlePasswordReset(evt: Event) {
    evt.preventDefault();
    this.error = '';
    try {
      await AuthApi.resetPassword({
        code: this.$route.params.id,
        password: this.model.password,
        passwordConfirm: this.model.passwordConfirm,
      });
      this.done = true;
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.addError(
        apiErrors['passwordisNotEmpty'] ||
          apiErrors['passwordminLength'] ||
          apiErrors['PasswordPolicy'],
        'password',
        'Bitte beachte, dass das Passwort mindestens 8 Zeichen, ein Sonderzeichen und eine Zahl beinhalten muss.',
      );

      this.addError(
        apiErrors['passwordConfirmisNotEmpty'] || apiErrors['passwordConfirmminLength'],
        'passwordConfirm',
        'Die Passwortbestätigung muss übereinstimmen.',
      );

      this.$toastr.e('Beim Bestätigen des Benutzerkontos ist etwas schief gelaufen.', 'Oops');

      throw e;
    }
  }
}
export default ResetPassword;
